import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "control-panel" }
const _hoisted_2 = { class: "row submit-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-save right" }, null, -1)
const _hoisted_4 = { class: "text-label" }
const _hoisted_5 = { class: "chart-container" }
const _hoisted_6 = { class: "instructions" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PersonForm = _resolveComponent("PersonForm")!
  const _component_Button = _resolveComponent("Button")!
  const _component_LineGraph = _resolveComponent("LineGraph")!
  const _component_chart_list = _resolveComponent("chart-list")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["progression-container", _ctx.wrapperClasses])
  }, [
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_PersonForm, {
        context: "main",
        onUpdate: _ctx.updatePerson
      }, null, 8, ["onUpdate"]),
      _createVNode(_component_PersonForm, {
        context: "partner",
        onUpdate: _ctx.updatePerson
      }, null, 8, ["onUpdate"]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.hasPairs)
          ? _withDirectives((_openBlock(), _createElementBlock("strong", {
              key: 0,
              class: "circle pair-num",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleChartList && _ctx.toggleChartList(...args)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.currentRefNum), 1)
            ])), [
              [
                _directive_tooltip,
                _ctx.refNumTooltip,
                void 0,
                { top: true }
              ]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_Button, { onClick: _ctx.save }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.saveLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_ctx.hasPairs)
          ? _withDirectives((_openBlock(), _createElementBlock("i", {
              key: 1,
              class: "pi pi-plus-circle reset-trigger trigger large",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
            }, null, 512)), [
              [
                _directive_tooltip,
                _ctx.resetTooltip,
                void 0,
                { right: true }
              ]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_LineGraph, { chartData: _ctx.chartData }, null, 8, ["chartData"])
    ]),
    _createVNode(_component_chart_list, {
      pairs: _ctx.pairs,
      refNum: _ctx.currentRefNum,
      puid: _ctx.puid,
      updating: _ctx.listUpdating
    }, null, 8, ["pairs", "refNum", "puid", "updating"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("i", {
        class: "pi pi-times-circle top right close trigger",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeOverlay && _ctx.closeOverlay(...args)))
      }),
      (_ctx.showInstructions)
        ? (_openBlock(), _createElementBlock("article", {
            key: 0,
            innerHTML: _ctx.instructions
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    (_ctx.hasPairs)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          class: "pi pi-cog chartlist-trigger trigger",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleChartList && _ctx.toggleChartList(...args)))
        }))
      : _createCommentVNode("", true)
  ], 2))
}